import PanelMapMixin from '@/app/shared/mixins/parts/PanelMap';
import CommonFeaturesMixin from './../../../shared/mixins/CommonFeaturesMixin';

export default {
    mixins: [
        PanelMapMixin,
        CommonFeaturesMixin,
    ],
    props: {

    },
    data() {
        return {
        }
    },
}